import { getLayoutTopbarHeightPx } from '@indutrust/shared-util';

import { smoothScrollWindowTo } from '../scroll/smooth-scroll-window.util';
import type { FactorySection } from './factory-section-status.util';

/** Extra gap below the sticky action bar when scrolling to a section. */
const SCROLL_BUFFER_PX = 12;

const ACTION_BAR_SELECTOR = '[data-testid="factory-edit-action-bar"]';
const SECTION_JUMPER_SELECTOR = '[data-testid="factory-edit-section-jumper"]';

function visibleChromeHeightPx(selector: string): number {
  if (typeof document === 'undefined') {
    return 0;
  }
  const element = document.querySelector(selector);
  if (!(element instanceof HTMLElement)) {
    return 0;
  }
  if (getComputedStyle(element).display === 'none') {
    return 0;
  }
  return element.getBoundingClientRect().height;
}

/**
 * Measures the pixel offset needed to scroll a factory editor section
 * below the fixed topbar, sticky action bar, and mobile section jumper.
 */
export function getFactoryEditScrollOffsetPx(): number {
  return (
    getLayoutTopbarHeightPx() +
    visibleChromeHeightPx(ACTION_BAR_SELECTOR) +
    visibleChromeHeightPx(SECTION_JUMPER_SELECTOR) +
    SCROLL_BUFFER_PX
  );
}

/**
 * Smooth-scrolls the document so a section card sits below the sticky chrome.
 * Resolves once the scroll settles (via `scrollend` or a timeout fallback).
 */
export async function scrollToFactoryEditSection(
  section: FactorySection
): Promise<void> {
  const win = globalThis.window as Window | undefined;
  if (win === undefined) {
    return;
  }
  const target = document.getElementById(`factory-edit-section-${section}`);
  if (!target) {
    return;
  }
  const top =
    target.getBoundingClientRect().top +
    win.scrollY -
    getFactoryEditScrollOffsetPx();
  return smoothScrollWindowTo(top);
}
